function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Typography, Container } from '@material-ui/core';
import { Particles } from '@blackbox-vision/react-particles';
import { useStyles } from "./styles.js";
export const Hero = ({
  id,
  height,
  title,
  titleProps,
  subtitle,
  subtitleProps,
  particlesConfig,
  gradient,
  children,
  clip
}) => {
  const classes = useStyles({
    clip,
    height,
    gradient
  });
  return /*#__PURE__*/React.createElement("section", {
    id: id,
    className: classes.section
  }, /*#__PURE__*/React.createElement(Particles, {
    id: id,
    height: "0",
    params: particlesConfig
  }), /*#__PURE__*/React.createElement(Container, {
    maxWidth: "md",
    className: classes.titlesContainer
  }, /*#__PURE__*/React.createElement(Typography, _extends({
    align: "center",
    component: "h1",
    variant: "h4",
    className: classes.title,
    gutterBottom: true
  }, titleProps), title), /*#__PURE__*/React.createElement(Typography, _extends({
    align: "center",
    component: "h2",
    variant: "h6",
    className: classes.subtitle,
    gutterBottom: true
  }, subtitleProps), subtitle), children));
};
Hero.defaultProps = {
  id: 'hero',
  clip: 'left',
  particlesConfig: {
    particles: {
      number: {
        value: 175,
        density: {
          enable: false
        }
      },
      size: {
        value: 3,
        random: true,
        anim: {
          speed: 4,
          size_min: 0.3
        }
      },
      line_linked: {
        enable: false
      },
      move: {
        random: true,
        speed: 1,
        direction: 'top',
        out_mode: 'out'
      }
    },
    interactivity: {
      events: {
        onhover: {
          enable: false,
          mode: 'bubble'
        },
        onclick: {
          enable: true,
          mode: 'repulse'
        }
      },
      modes: {
        bubble: {
          distance: 250,
          duration: 2,
          size: 10,
          opacity: 0
        },
        repulse: {
          distance: 400,
          duration: 4
        }
      }
    },
    retina_detect: true
  }
};
Hero.displayName = 'Hero';
export default Hero;